var map = {
	"./acme/lang.json": 1030,
	"./audacy/lang.json": 1031,
	"./flipkart/lang.json": 1032,
	"./foobars_store/lang.json": 1033,
	"./hotstar/lang.json": 1034,
	"./walmart/lang.json": 1035,
	"./walmartcam/lang.json": 1036,
	"./walmartcentralamerica/lang.json": 1037,
	"./walmartchile/lang.json": 1038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1029;